export default __webpack_public_path__ + "media/music/a48d1a005844d243a39fe054cdb0f85a.mp3";